import { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { api, formatApiError } from "@/lib/api";
import { printAppPage } from "@/lib/print";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { useWaMsg, vehicleShort } from "@/lib/waTemplates";
import { QrCode, Copy, MessageCircle, Printer, RefreshCw, ExternalLink } from "lucide-react";

export const waLink = (phone, text) => {
  const d = String(phone || "").replace(/\D/g, "");
  return `https://wa.me/${d.startsWith("55") ? d : `55${d}`}?text=${encodeURIComponent(text)}`;
};

export function OrderQrCard({ order }) {
  const [link, setLink] = useState(null);
  const waMsg = useWaMsg();
  useEffect(() => {
    api.get(`/orders/${order.id}/public-link`).then(({ data }) => setLink(data.url)).catch((e) => toast.error(formatApiError(e)));
  }, [order.id]);
  const rotate = async () => {
    if (!window.confirm("Gerar um novo link? O QR Code antigo (etiqueta/PDF já impressos) deixa de funcionar.")) return;
    try { const { data } = await api.post(`/orders/${order.id}/public-link/rotate`); setLink(data.url); toast.success("Novo link gerado"); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  const copy = async () => { try { await navigator.clipboard.writeText(link); toast.success("Link copiado"); } catch { toast.info(link); } };
  const msg = waMsg("track_link", { cliente: order.customer_name || "", placa: order.vehicle?.plate || "", modelo: vehicleShort(order.vehicle), link });
  return (
    <div data-testid="order-qr-card" className="rounded-2xl border border-card2-border bg-appbg-soft/40 p-4 flex flex-col sm:flex-row gap-4 items-start">
      <div className="bg-white p-2 rounded-lg shrink-0" data-testid="order-qr-code">
        {link ? <QRCodeSVG value={link} size={112} /> : <div className="h-[112px] w-[112px]" />}
      </div>
      <div className="flex-1 min-w-0 space-y-2">
        <div className="flex items-center gap-2 text-xs font-mono-caps text-zinc-500 uppercase tracking-widest"><QrCode className="h-4 w-4" /> Acompanhamento do cliente</div>
        <p className="text-sm text-zinc-400">O cliente aponta a câmera, digita os 4 últimos dígitos do telefone e vê status, fotos, orçamento, revisão e garantia, sem login.</p>
        <div className="flex flex-wrap gap-2">
          <Button data-testid="qr-print-label-btn" size="sm" variant="outline" disabled={!link} onClick={() => printAppPage(`/owner/ordens/${order.id}/etiqueta`)} className="bg-zinc-900 border-zinc-800"><Printer className="h-4 w-4 mr-1" /> Imprimir etiqueta QR</Button>
          <Button data-testid="qr-copy-btn" size="sm" variant="outline" disabled={!link} onClick={copy} className="bg-zinc-900 border-zinc-800"><Copy className="h-4 w-4 mr-1" /> Copiar link</Button>
          {order.customer_phone && link && <a data-testid="qr-wa-btn" href={waLink(order.customer_phone, msg)} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 h-9 px-3 rounded-md bg-emerald-600 hover:bg-emerald-500 text-white text-sm font-semibold"><MessageCircle className="h-4 w-4" /> WhatsApp</a>}
          {link && <a data-testid="qr-open-btn" href={link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 h-9 px-3 rounded-md border border-zinc-800 bg-zinc-900 text-zinc-300 text-sm"><ExternalLink className="h-4 w-4" /> Abrir</a>}
          <Button data-testid="qr-rotate-btn" size="sm" variant="ghost" onClick={rotate} className="text-zinc-400 hover:text-zinc-100"><RefreshCw className="h-4 w-4 mr-1" /> Gerar novo link</Button>
        </div>
      </div>
    </div>
  );
}
